import React from 'react'
import { FlexRow, Button, TabBar } from 'elements'

export default function OrganizationHeader({ sections, sectionsValue, button }) {
  return (
    <FlexRow bg="nav.secondary" justifyContent="center" height="60px" position="relative">
      {sections ? (
        <TabBar
          tabs={sections}
          value={sectionsValue}
          onChange={(tab) => {
            tab.onSelect()
          }}
        />
      ) : null}
      <FlexRow position="absolute" right="0" bg="background.0">
        {button ? (
          <Button
            kind={button.disabled ? 'disabled' : 'primary'}
            area="xlarge"
            shape="block"
            onClick={button.onClick}
            disabled={button.disabled}
          >
            {button.text}
          </Button>
        ) : null}
      </FlexRow>
    </FlexRow>
  )
}
